import { MetricColorScale } from '../Styles/MetricColorScale';
import { MetricLayer } from './MetricLayer';
/**
 * Surface chlorophyll-a concentration (mg/m³) sourced from NOAA
 * CoastWatch ERDDAP via the backend OceanService. Higher values =
 * higher primary productivity = more food in the water column.
 *
 * Range is hard-coded for now: 0..3 mg/m³ covers the bulk of the
 * Canary Islands and Strait of Gibraltar values; the upper end clamps
 * to red for true blooms (>3) without losing resolution at typical
 * working ranges. Swap to a per-tenant config once a second region
 * starts using the page.
 */
export class ChlorophyllMetricLayer extends MetricLayer {
    constructor() {
        // ColorBrewer YlGn 5-class, low → high.
        super(new MetricColorScale(['#ffffcc', '#c2e699', '#78c679', '#31a354', '#006837'], 0, 3));
    }
    getName() {
        return 'metric_chlorophyll_layer';
    }
    getTitle() {
        return 'Chlorophyll-a (mg/m³, day mean)';
    }
    getProvenance() {
        return 'NOAA CoastWatch ERDDAP (erdMH1chla1day)';
    }
    getUnit() {
        return 'mg/m³ surface chl-a, daily mean';
    }
}
